import React from "react"
import { ModalState } from "."
import { ContactFormResultType } from "../../../common/enums"

/**
 * Provides helper functions for dispatch middleware
 */
class DispatchMiddlewareHelper {
  constructor(private dispatch: React.Dispatch<any>) {}

  setIsLoading = (isLoading: boolean) => {
    this.dispatch({
      type: ContactFormResultType.SetLoading,
      payload: { isLoading },
    })
  }

  setIsModalOpen = (isModalOpen: boolean) => {
    this.dispatch({
      type: ContactFormResultType.SetModalOpen,
      payload: { isModalOpen },
    })
  }

  setModalState = (modalState: ModalState) => {
    this.dispatch({
      type: ContactFormResultType.SetModalState,
      payload: { modalState },
    })
  }
}

export default DispatchMiddlewareHelper
